import { CustomerType } from "../interfaces/common/customer";

export const showCustomerAutocompleteOption = (option: CustomerType): string => option.id.length == 0 ? '' : option.name + ' | ' + option.phone_number + ' | ' + option.merchant?.name
